import React from 'react';
import Wrapper from '../../components/videoLayer/Wrapper';
import Leave from '../../components/videoLayer/Leave';
import Button from '../../components/videoLayer/Button';
import Message from '../../components/videoLayer/Message';
import VideoWrap from '../../components/videoLayer/VideoWrap';
import Video from '../../components/videoLayer/Video';
import { LayerPosition } from '../../types';

interface Props {
    style: LayerPosition;
    popupClose: () => void;
}

const VideoPopupLayer: React.FC<Props> = ({
    style,
    popupClose,
}) => {
    return (
        <Wrapper style={style}>
            <Leave>
                <Button handleClose={popupClose}>닫기</Button>
                <Message>힐링컨텐츠</Message>
                <VideoWrap>
                    <Video />
                </VideoWrap>
            </Leave>
        </Wrapper>
    )
}

export default VideoPopupLayer;